import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import { mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { get } from "lodash-es";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PopoverSetGroupDefault from "views/ProjectGroupPage/components/PopoverSetGroupDefault";
import ShareIcon from "@mui/icons-material/Share";
import styled from "styled-components";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";
import { Box } from "@mui/material";
import ReactDOMServer from "react-dom/server";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MenuOutlinedIconCus = () => (
  <MenuOutlinedIcon
    sx={{
      width: "1.3em",
      height: "1.3em",
    }}
    style={{ color: "#787878" }}
  />
);

const StyledMenuOutlinedIcon = styled(MenuOutlinedIconCus)`
  padding: 3px;
  cursor: pointer;
  color: #787878;
  border-radius: 3px;
`;

export const TitleTable = ({
  currentGroup,
  typeData,
  expand,
  onExpand = () => {},
  isAllGroup = false,
}) => {
  const { t } = useTranslation();
  const query = useQuery();
  const isShared = query.get("is-shared");
  const isAllProjects = !!!currentGroup?.name;
  const groupName = isShared
    ? t("LABEL_SHARED_GROUP")
    : get(currentGroup, "name", t("LABEL_WORKING_GROUP"));

  const _renderIconExpand = (event) => {
    return <StyledMenuOutlinedIcon onClick={() => onExpand(!expand)} />;
  };

  const refSetGroupDefault = useRef(null);

  const _handleOpenSetGroup = (event) => {
    refSetGroupDefault.current._open(event.currentTarget, currentGroup);
  };

  const _renderTitleRecently = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }`}
    >
      {_renderIconExpand()}
      <span>{t("LABEL_SEE_RECENTLY")}</span>
    </div>
  );

  const _renderTitlePersonal = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }
  `}
    >
      {_renderIconExpand()}
      <span>{t("LABEL_PERSONAL_BOARD")}</span>
    </div>
  );

  const _renderTitleAllProject = () => (
    <div
      className={`view_ProjectGroup_Table_All_titleTop ${
        isAllGroup ? "is-all-group" : ""
      }`}
      style={{ transform: "translateX(-8px)" }}
    >
      <Box
        sx={{
          "&:hover": {
            background: "#EBEDF0",
          },
        }}
        style={{
          transform: `${expand ? "scale(-1, -1)" : "scale(1, 1)"}`,
          marginRight: 10,
          padding: 5,
          borderRadius: 7,
        }}
        onClick={() => onExpand(!expand)}
        onMouseEnter={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOpenOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
        onMouseLeave={(e) =>
          (e.currentTarget.firstElementChild.innerHTML =
            ReactDOMServer.renderToString(
              <MenuOutlinedIcon sx={{ fontSize: 28, color: "#787878" }} />
            ))
        }
      >
        {_renderIconExpand()}
      </Box>
      <div style={{ display: "flex" }}>
        <abbr title={t("DELETED_GROUP")}>{t("DELETED_GROUP")}</abbr>
      </div>
      {!isAllProjects && <PopoverSetGroupDefault ref={refSetGroupDefault} />}
    </div>
  );

  function resolveTitle() {
    switch (typeData) {
      case 1:
        return _renderTitleRecently();
      case 2:
        return _renderTitlePersonal();
      default:
        return _renderTitleAllProject();
    }
  }

  return <>{resolveTitle()}</>;
};

const DefaultGroupIcon = ({ idGroup = "" }) => {
  const idGroupDefault = useSelector(
    ({ groupTask }) => groupTask.defaultGroupTask.data || ""
  );
  const idGroupDefaultLocal = localStorage.getItem(
    "WPS_WORKING_SPACE_DEFAULT_ACCESS"
  );

  if (
    idGroupDefault === `?groupID=${idGroup}` ||
    `?groupID=${idGroup}` === idGroupDefaultLocal
  ) {
    return (
      <div className="wp-wrapper-button">
        <FlagOutlinedIcon style={{ color: "#666" }} />
      </div>
    );
  }

  return null;
};
